import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnInit,
	OnDestroy,
	ViewChild,
	ElementRef
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ButtonLabel, ButtonState, Icon, Modal, ModalEvent, ModalState, NavButtonState } from './definitions';
import { ModalFactory } from './modal.factory';
@Component({
	selector: 'kng-modal-component',
	templateUrl: './template/modal.component.html',
	styleUrls: ['./template/modal.component.scss']
})
export class ModalComponent implements Modal, OnInit, OnDestroy
{
	private subscriptions$: Subscription = new Subscription();
	showTooltip:boolean = false;
	arrowLeft: string | undefined = Icon.arrowLeft;
	editBtnLabel = ButtonLabel.editNewLocation;
	private state$: BehaviorSubject<ModalState> = new BehaviorSubject<ModalState>(
		ModalFactory.build()
	);
	get state(): ModalState
	{
		return this.state$.value;
	}
	@ViewChild('toolTipRef') toolTipRef!: HTMLDivElement;
  @ViewChild('modalContainer', { static: true })
  	modalContainer!: ElementRef<HTMLDivElement>;

  @Input() set state(value: ModalState)
  {
  	this.state$.next(value);
  	if (!value.hidden)
  	{
  		this.openModal();
  	}
  	else
  	{
  		this.closePopup();
  	}
  }

  @Output() stateChanged: EventEmitter<ModalState> =
  	new EventEmitter<ModalState>();
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();
  @Output() opened: EventEmitter<void> = new EventEmitter<void>();
  @Output() ctaClickedOn: EventEmitter<ModalEvent> =
  	new EventEmitter<ModalEvent>();
  @Output() tooltipClicked: EventEmitter<void> =
  	new EventEmitter<void>();
  @Output() checkBoxClicked : EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() navBtnClicked : EventEmitter<void> = new EventEmitter<void>();

  @Input() checkBoxText?: string;
  @Input() checkBoxTickedFlag: boolean = false;
  @Input() checBoxDisabledFlag: boolean = true;
  @Input() navBtnRequired: boolean = false;
  @Input() navBtnState: NavButtonState = {
  		btnRequired: false,
  		btnLabel: ''
  	};
  private stateChangeHandler(modalState: ModalState)
  {
  	this.stateChanged.emit(modalState);
  }

  ngOnInit(): void
  {
  	const stateChangedSubscription: Subscription = this.state$.subscribe(
  		(next: ModalState) => this.stateChangeHandler(next)
  	);
  	this.subscriptions$.add(stateChangedSubscription);
  }

  ngOnDestroy(): void
  {
  	this.subscriptions$.unsubscribe();
  }
  closePopup()
  {
  	document.getElementById('kng-modal-close')?.click();
  	this.state.hidden = true;
  	this.closed.emit();
  	this.hideModalBackdrop();
  }
  openModal()
  {
  	document.getElementById('kng-open-modal')?.click();
  	this.state.hidden = false;
  	this.opened.emit();
  }

  emitCtaClickEvent(cta: ButtonState)
  {
  	const eventEmitted: ModalEvent = { state: this.state, cta: cta };
  	this.checBoxDisabledFlag = true;
  	this.ctaClickedOn.emit(eventEmitted);
  }
  openTooltip(eleRef: HTMLDivElement): void
  {
  	if(this.state.tooltip?.content && eleRef)
  	{
  		this.showTooltip = true;
  		setTimeout(() => eleRef.focus(), 100);
  	}
  }

  closeTooTip(eleRef: HTMLDivElement): void
  {
  	if(this.state.tooltip?.content && eleRef)
  	{
  		this.showTooltip = false;
  		setTimeout(() => eleRef.focus(), 100);
  	}
  }
  hideModalBackdrop()
  {
  	document.body.classList.remove('modal-open');
  	document.body.removeAttribute('style');
  	const backdrop = document.querySelector('.modal-backdrop');
  	backdrop?.remove();
  }
  showMobileTooltip()
  {
	  this.tooltipClicked.emit();
  }

  checkBoxClickEvent()
  {
  	if(this.checkBoxTickedFlag)
  	{
  		this.checkBoxClicked.emit(true);
  	}
  	else
  	{
  		this.checkBoxClicked.emit(false);
  	}
  }

  navBtnclick() 
  {
  	this.navBtnClicked.emit();
  }
}
